import React, { FC, useContext } from 'react';
import { LicensesContext } from '../../contexts/LicensesContext';
import { ELicenseMode } from '../../models/ILicense';
import { getLicenseStatus } from '../../helpers/licenseStatus';

export const AirgappedBtnGuard: FC = ({ children }) => {
  const { licenses } = useContext(LicensesContext);

  if (
    licenses?.some(
      (l) =>
        l.mode === ELicenseMode.Unused &&
        ['expiresSoon', 'valid'].includes(getLicenseStatus(l.suspended, l.expiresAt, l.planType)) &&
        !l.isDiscovery
    )
  ) {
    return <>{children}</>;
  }

  return null;
};
